import React, { useState } from "react";
import "./adminMember.css";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { IP } from "../../../../../internalServer";
import { getInitial } from "../../../../../utils/Engagement";

const AdminMember = ({
  admin,
  inEditingMode,
  setEditingAllMembersDetails,
  editingAllMembersDetails,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
  creatorId,
}) => {
  const { deletingAdmins } = deletingAllMembersDetails;
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const handleRoleChange = (e) => {
    !editingAllMembersDetails.some((member) => member.memberId === admin.id)
      ? setEditingAllMembersDetails((prev) => [
        ...prev,
        {
          previousRole: "admin",
          nextRole: e.target.value,
          memberId: admin.id,
        },
      ])
      : setEditingAllMembersDetails(
        editingAllMembersDetails.map((item) => {
          if (item.memberId === admin.id) {
            return { ...item, nextRole: e.target.value };
          } else {
            return item;
          }
        })
      );
  };

  const handleDeleteMember = () => {
    if (deletingAdmins.includes(admin.id)) {
      const newAdminsList = deletingAdmins.filter((a) => a !== admin.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingAdmins: newAdminsList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingAdmins: [...prev.deletingAdmins, admin.id],
      }));
    }
  };

  // ${
  //         (admin?.admin?.id === teacher_id || creatorId === admin?.admin?.id) &&
  //         inEditingMode &&
  //         "member_bg_color"
  //       }

  return (
    <>
      <div
        className={`col-12 p-0 mb-1 d-flex gap-3 align-items-center`}
      >
        <div className="col-8 p-0 mt-3 gap-2 d-flex align-items-center">
          <div className=" d-flex align-items-center justify-content-center">
            {
              admin?.role === "admin" || "B4sAdmin" ?
                <img
                  src={
                    admin?.admin?.profilePicture
                      ? IP + admin?.admin?.profilePicture.replace(/^\./, "")
                      : admin?.admin?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : admin?.admin?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer" }}
                  key={admin?.admin?.avatarProfile}
                  onError={(e) => {
                    if (admin?.admin?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg"
                    } else if (admin?.admin?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                /> : <img style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }} src="/images/default image.png" alt="" />
            }
          </div>
          <span className="">{admin?.admin?.name} </span>
          {admin?.admin?.id === teacher_id && (
            <span className="you">
              {/* (you) */}
            </span>
          )}
          {creatorId === admin?.admin?.id && (
            <span className="you">
              {/* (creator) */}
            </span>
          )}
        </div>
        {inEditingMode ? (
          <div className="gap-3 d-flex">
            {admin?.admin.id !== teacher_id &&
              creatorId !== admin?.admin?.id ? (
              <Form.Select
                onChange={(e) => handleRoleChange(e)}
                className={`${editingAllMembersDetails.some(
                  (member) => member.memberId === admin.id
                ) && `select_option_change`
                  } custom-select`}
                size="sm"
              >
                <option value="admin">ADMIN</option>
                <option value="moderator">MODERATOR</option>
                <option value="member">MEMBER</option>
              </Form.Select>
            ) : (
              <span className="roleStyle">ADMIN</span>
            )}
            {!deletingAdmins.includes(admin.id) ? (
              <>
                {admin?.admin.id !== teacher_id &&
                  creatorId !== admin?.admin?.id && (
                    <img
                      onClick={handleDeleteMember}
                      src="/images/Dustbin.svg"
                      alt=""
                    />
                  )}
              </>
            ) : (
              <img
                onClick={handleDeleteMember}
                src="/images/redDustbin.svg"
                alt=""
              />
            )}
          </div>
        ) : (
          <span className="roleStyle">ADMIN</span>
        )}
      </div>
    </>
  );
};

export default AdminMember;
